import { facadeApi } from 'api'

interface RoleRelation {
  account_id: string
  account_name: string
  relation_id: string
  role_id: string
  role_name: string
}

export interface UserAssignedRoles extends RoleRelation {
  email: string
  user_id: string
}

export const fetchUserAssignedRolesApi = ({ id, email }: { id: string; email: string }) =>
  facadeApi.post<UserAssignedRoles[]>('/az/users/assigned-roles/search', {
    offset: 0,
    limit: 1000,
    user_ids: [id],
    user_emails: [email],
  })
